<template>

  <ValidationObserver v-slot="{ invalid }">
    <vx-card
      :title="$t('class-over-view.class-material')"
      class="w-full mb-5"
      title-color="primary" v-if="classMaterials"
    >
      <template slot="actions">
        <vx-tooltip :text="$t('general.add') + $t('class-over-view.class-material')" class="float-right">
          <vs-button radius color="dark" type="flat" icon-pack="feather" icon="icon-plus"
                     @click="onAddClick"></vs-button>
        </vx-tooltip>
      </template>

      <!--EDIT FORM-->
      <div v-if="showEditForm">
        <div class="vx-row">
          <div class="vx-col w-1/2 sm:w-full mb-2">
            <ValidationProvider :name="$t('class-material.sequence')" rules="required|numeric" v-slot="{ errors }">
              <vs-input :label="$t('class-material.sequence') + ' *'" class="w-full"
                        @input="onSequenceInput()"
                        v-model.number="form.classMaterialInput.sequence"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <ValidationProvider :name="$t('live-class-schedule.topic-local')" rules="required" v-slot="{ errors }">
              <vs-input :label="$t('live-class-schedule.topic-local') + ' *'" class="w-full"
                        v-model="form.classMaterialInput.nameLocal"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="vx-col w-full mb-2">
            <vs-input :label="$t('live-class-schedule.topic-eng')" class="w-full"
                      v-model="form.classMaterialInput.nameEng"/>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full my-4">
            <vs-radio v-model="uploadFileType"
                      vs-value="document"
                      class="mr-4"
                      vs-name="layout-type-horizontal">
              {{ $t('class-material.document') }}
            </vs-radio>
            <vs-radio v-model="uploadFileType"
                      vs-value="video"
                      class="mr-4"
                      vs-name="layout-type-horizontal">
              {{ $t('class-material.video') }}
            </vs-radio>
          </div>
        </div>

        <!--DOCUMENT UPDATE-->
        <div class="vx-row" v-if="uploadFileType === 'document'">
          <div class="vx-col w-full mb-2">
            <div class="flex items-center">
              <input type="file" class="hidden" ref="uploadIInput"
                     @change="onFilUploadChange"
                     :accept="acceptFileType">
              <vx-tooltip :title="$t('class-material.upload')" class="float-left">
                <vs-button color="primary" icon-pack="feather" icon="icon-upload"
                           @click="$refs.uploadIInput.click()"/>
              </vx-tooltip>
              <span class="ml-2" v-if="fileUploadName">{{ fileUploadName }}</span>
              <span class="ml-2" v-else>{{ $t('class-material.document-type-allow') }}</span>
            </div>
          </div>
        </div>

        <!--VIDEO UPLOAD-->
        <div class="vx-row" v-else>
          <div class="vx-col w-full mb-2">
            <vue-dropzone id="dropzone" ref="myVueDropzone"
                          :options="dropzoneOptions"
                          :useCustomSlot=true
                          @vdropzone-success="onUploadSuccess"
                          @vdropzone-error="onUploadError"
                          @vdropzone-sending="sendingEvent"
                          @vdropzone-file-added="validateBeforeUpload">
              <p class="text-lg text-success text-bold">{{ $t('class-material.upload-video') }}</p>
              <p class="text-sm">{{ $t('vdo-set-topic.drop-file-here') }}</p>
            </vue-dropzone>
          </div>
        </div>

        <!----------------------------------------- Actions Button ---------------------------------------------------->
        <div class="vx-row pt-2">
          <div class="vx-col w-full">
            <vs-button :disabled="local.isProcessing || invalid || isUploading || !fileUpload"
                       class="mr-2"
                       @click.prevent="onSaveClick">
              {{ $t('general.save') }}
            </vs-button>

            <vs-button type="border" color="warning"
                       :disabled="local.isProcessing || isUploading"
                       @click.prevent="onCancelClick()">
              {{ $t('general.cancel') }}
            </vs-button>
          </div>
        </div>

        <vs-divider/>

      </div>

      <!--LIST ITEM-->

      <div class="block overflow-x-auto">
        <table class="w-full">
          <tr>
            <th class="px-3 py-2">
              <vs-chip transparent color="primary">
                <span>{{ $t('live-class-schedule.topic') }}</span>
              </vs-chip>
            </th>
            <th class="font-semibold text-base text-left" width="80">
              <!--<vs-chip transparent color="primary">
                <span>{{ $t('class-over-view.due-date') }}</span>
              </vs-chip>-->
            </th>
          </tr>

          <tr v-for="item in classMaterials" :key="item.id">
            <td class="px-3 py-2 flex items-center">
              <feather-icon v-if="item.uploadFileName && !isVideoType(item)"
                            @click="onDownloadClick(item)" class="mr-2 cursor-pointer"
                            icon="DownloadIcon"
                            svgClasses="w-5 h-5 text-primary stroke-current"/>
              <feather-icon v-if="item.uploadFileName && isVideoType(item)"
                            @click="onPlayClick(item)" class="mr-2 cursor-pointer"
                            icon="PlayIcon"
                            svgClasses="w-5 h-5 text-primary stroke-current"/>
              {{ item.sequence }} {{ item.nameLocal }}
            </td>
            <td class="px-3 py-2 text-right">
              <feather-icon @click="onEditClick(item)" class="mr-2 cursor-pointer"
                            icon="EditIcon"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
              <feather-icon @click="onDeleteClick(item)"
                            icon="TrashIcon" class="cursor-pointer"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
            </td>
          </tr>
        </table>
      </div>


      <vs-prompt full-screen
                 :active.sync="activePrompt"
                 :title="$t('vdo-set-topic.preview')"
                 :buttons-hidden="true"
                 @cancel="closePreviewVideo"
                 @close="closePreviewVideo"
                 class="preview-video">

        <preview-video-card :current-vdo-set-topic="videoPreview"></preview-video-card>
      </vs-prompt>

    </vx-card>
  </ValidationObserver>

</template>

<script>
import VueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import PreviewVideoCard from "@/views/pages/ClassOverview/Components/PreviewVideoCard";

import ClassMaterial from '@/store/modules/courses/class-material/index';
import {state} from "../data";
import {showStateNotification, showLocalNotification, notificationType} from "@/utils/notification";
import {confirmDelete, confirmSave} from "@/utils/dialogs";
import {dateTimeFormat} from "@/utils/format";
import {config} from "@/utils/upload";
import {createNamespacedHelpers} from "vuex";
import {createHelpers} from "vuex-map-fields";
import {getECode, getRStage, getToken} from "@/utils/auth-data";

if (!state.store.ClassMaterial) state.registerModule(`ClassMaterial`, ClassMaterial);

const {
  mapActions: mapClassMaterialActions,
} = createNamespacedHelpers(`ClassMaterial`);


const {
  mapFields: mapClassMaterialFields,
} = createHelpers({
  getterType: `ClassMaterial/getField`,
  mutationType: `ClassMaterial/updateField`,
});

export default {
  props: {
    classRoom: Object
  },
  components: {
    VueDropzone,
    PreviewVideoCard
  },
  data() {
    return {
      local: state.local,

      dateTimeFormat: dateTimeFormat,
      showEditForm: false,
      isUploading: false,
      acceptFileType: config.fileExtension.document,
      form: {
        id: '',
        classMaterialInput: {
          sectionNo: null,
          sequence: null,
          nameLocal: null,
          nameEng: null,
          uploadPath: null,
          uploadPathUri: null,
          uploadFileName: null,
        }
      },

      fileUpload: null,
      uploadFileType: 'document',

      // for video upload
      uploadPayload: {
        fileName: '',
        teacherCode: '',
        periodCode: '',
        subjectCode: '',
        sectionNo: '',
        learnSpanNo: '',
        vdoLength: 0,
        r_stage: getRStage,
        e_code: getECode,
        authorization: getToken,
        app: "teacher",
        appName: "xstudi"
      },
      headers: {
        'content-type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "Content-Type, Accept",
        'Access-Control-Allow-Credentials': true
      },
      dropzoneOptions: {
        url: config.url.vdoMaterialApi,
        paramName: 'video-material',
        enctype: 'multipart/form-data',
        thumbnailHeight: 160,
        maxFilesize: 40930, // MB
        acceptedFiles: '.mov,.mp4,.m4a,.m4v,.3gp,.3g2,.mj2',
        maxFiles: 1,
        chunking: true,
        chunkSize: 1024000, // Bytes
        duplicateCheck: true,
        timeout: 1000 * 60 * 60 * 20, //2 hrs
        useCustomDropzoneOptions: true,
      },
      loading: false,

      //for preview video
      activePrompt: false,
      videoPreview: null,

    }
  },
  computed: {
    ...mapClassMaterialFields({
      classMaterialProcessing: 'processing',
      classMaterialSuccess: 'success',
      classMaterialError: 'error',
    }),
    classMaterials() {
      return this.classRoom ? this.classRoom.classSection.classMaterials : [];
    },
    showFileUpload() {
      return !!this.form.id;
    },
    fileUploadName() {
      return this.fileUpload ? this.fileUpload.name : '';
    }
  },
  watch: {
    classMaterialProcessing(data) {
      this.local.isProcessing = data;
    },
    classMaterialSuccess(data) {
      showStateNotification(this.$vs, data);
    },
    classMaterialError(data) {
      showStateNotification(this.$vs, data);
    }
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapClassMaterialActions({
      getClassMaterial: 'getClassMaterial',
      addClassMaterial: 'addClassMaterial',
      updateClassMaterial: 'updateClassMaterial',
      deleteClassMaterial: 'deleteClassMaterial',
      uploadMaterial: 'uploadMaterial',
    }),
    //---------------------------------------- Event Function ------------------------------------------------------//
    onDownloadClick(item) {
      let url = config.url.downloadFile + item.uploadPathUri;
      window.open(url, '_blank');
    },
    onPlayClick(item) {
      this.activePrompt = true;
      this.videoPreview = {
        vdoStreamPath: `${item.uploadPath}/${item.uploadPathUri}`
      };
    },
    onAddClick() {
      if (this.showEditForm === true) {
        this.showEditForm = false
      } else {
        this.form.id = null;
        this.form.classMaterialInput.sectionNo = this.classRoom.sectionNo;
        this.form.classMaterialInput.sequence = this.classMaterials.length + 1;
        this.form.classMaterialInput.nameLocal = null;
        this.form.classMaterialInput.nameEng = null;
        // this.form.classMaterialInput.uploadPath = null;
        // this.form.classMaterialInput.uploadPathUri = null;
        this.form.classMaterialInput.uploadFileName = null;

        this.fileUpload = null;
        this.showEditForm = true;
      }
    },
    onEditClick(tr) {
      this.form.id = tr.id;
      this.form.classMaterialInput.sectionNo = tr.sectionNo;
      this.form.classMaterialInput.sequence = tr.sequence;
      this.form.classMaterialInput.nameLocal = tr.nameLocal;
      this.form.classMaterialInput.nameEng = tr.nameEng;
      // this.form.classMaterialInput.uploadPath = tr.uploadPath;
      // this.form.classMaterialInput.uploadPathUri = tr.uploadPathUri;
      // this.form.classMaterialInput.uploadFileName = tr.uploadFileName;

      this.fileUpload = null;
      this.showEditForm = true;
    },
    onCancelClick() {
      this.showEditForm = false;
    },
    async onDeleteClick(tr) {
      await confirmDelete(this.$vs, this.removeClassMaterial, {id: tr.id});
    },
    async onSaveClick() {
      let payload = {
        classMaterialInput: {
          ...this.form.classMaterialInput
        },
      }
      if (!this.form.id) {
        //insert
        payload['classSectionId'] = this.classRoom.classSection.id;
      } else {
        //update
        payload['id'] = this.form.id;
      }

      await confirmSave(this.$vs, this.saveClassMaterial, payload);
    },
    async onFilUploadChange(e) {
      if (e.target.files && e.target.files.length > 0) {
        this.fileUpload = e.target.files[0];

        this.form.classMaterialInput.uploadFileName = e.target.files[0].name;

      } else {
        this.fileUpload = null;
        this.form.classMaterialInput.uploadFileName = '';
      }
    },
    onSequenceInput(){
      const sequence = this.classMaterials.find(e => e.sequence === this.form.classMaterialInput.sequence
        && e.id !== this.form.classMaterialInput.id)
      if(sequence){
        this.form.classMaterialInput.sequence = null
      }
    },
    async validateBeforeUpload() {
      if (!this.form.classMaterialInput.nameLocal) {
        showLocalNotification(this.$vs, this.$t('general.error')
          , this.$t('class-material.alert-no-title')
          , notificationType.ERROR);
        this.$refs['myVueDropzone'].removeAllFiles();
      }
    },
    async onUploadSuccess(file) {
      //call update function
      const response = JSON.parse(file.xhr.response);
      this.uploadPayload.fileName = response.original.name;
      showLocalNotification(this.$vs, this.$t('general.success')
        , this.$t('upload.upload-vdo-success', {fileName: this.uploadPayload.fileName})
        , notificationType.SUCCESS);
      this.isUploading = false;
      this.$refs['myVueDropzone'].removeAllFiles();
      let payload = {
        classMaterialInput: {
          ...this.form.classMaterialInput,
          uploadPath: response.original.path,
          uploadPathUri: response.original.name,
          uploadFileName: response.original.oldName,
        },
      }
      if (!this.form.id) {
        //insert
        payload['classSectionId'] = this.classRoom.classSection.id;
      } else {
        //update
        payload['id'] = this.form.id;
      }
      await this.saveClassMaterial(payload);
    },
    onUploadError() {
      showLocalNotification(this.$vs, this.$t('general.error')
        , this.$t('upload.upload-vdo-fail', {fileName: this.uploadPayload.fileName})
        , notificationType.ERROR);
      this.isUploading = false;
      this.$refs['myVueDropzone'].removeAllFiles();
    },
    sendingEvent(file, xhr, formData) {
      this.isUploading = true;
      formData.append('teacherCode', this.classRoom.teacherCode);
      formData.append('periodCode', this.classRoom.courseOutlineRegistration.periodCode.replace('/', '-'));
      formData.append('subjectCode', this.classRoom.subjectCode);
      formData.append('sectionNo', this.classRoom.classSection.sectionNo);
      formData.append('learnSpanNo', this.classRoom.classSection.learnSpanNo);
      formData.append('r_stage', getRStage);
      formData.append('e_code', getECode);
    },
    closePreviewVideo() {
      this.activePrompt = false;
      this.videoPreview = null;
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    async saveClassMaterial(payload) {
      let result;

      if (this.uploadFileType === 'document' && this.fileUpload) {
        //if have fileUpload then upload file
        let uploadPayload = {
          file: this.fileUpload,
          file1: this.form.classMaterialInput.uploadFileName,
          operationName: config.operationName.classMaterial,
          stage: getRStage,
          entity: getECode,
          authorization: getToken,
          app: "teacher"
        }
        let resultUpload = await this.uploadMaterial(uploadPayload);

        if (resultUpload) {
          payload.classMaterialInput['uploadPath'] = resultUpload.file.uuid;
          payload.classMaterialInput['uploadPathUri'] = resultUpload.file.uuid;
        }
      }

      if (!payload.id) {
        result = await this.addClassMaterial(payload);
      } else {
        result = await this.updateClassMaterial(payload);
      }

      if (result) {
        // update list
        result = JSON.parse(JSON.stringify(result));
        if (!payload.id) {
          //add new vdoLiveSetTopic to vdoLiveSetTopics list
          this.classRoom.classSection.classMaterials.push(result);

        } else {
          //update new vdoLiveSetTopic to vdoLiveSetTopics list
          const index = this.classRoom.classSection.classMaterials.findIndex(item => {
            return item.id === result.id
          });
          this.classRoom.classSection.classMaterials[index] = result;

        }
        this.showEditForm = false;
        this.form.id = result.id;
        // this.form.classMaterialInput.uploadPath = result.uploadPath;
        // this.form.classMaterialInput.uploadPathUri = result.uploadPathUri;
        // this.form.classMaterialInput.uploadFileName = result.uploadFileName;

      }
    },
    async removeClassMaterial(payload) {
      let result = await this.deleteClassMaterial(payload);

      if (result) {
        //remove list
        const index = this.classRoom.classSection.classMaterials.findIndex(item => item.id === result.id);
        this.classRoom.classSection.classMaterials.splice(index, 1);

        this.showEditForm = false;
      }
    },
    setVdoInfo(files, uploadPayload) {
      //set upload file name
      uploadPayload.fileName = files[0].name;
      uploadPayload.fileNameUpload = files[0].name;

      //set video info
      let video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = function () {
        window.URL.revokeObjectURL(video.src);
        uploadPayload.vdoLength = video.duration;
      }
      video.src = URL.createObjectURL(files[0]);

      return video;
    },
    isVideoType(item) {
      return item.uploadFileName.includes('.mp4');
    }
  },
}
</script>

<style scoped>

</style>
